<template>
<div class="height-100">
    <div class="visithistory-leftsection">
        <fdns-visithistory-leftsection @onClick="onClick" @dataOrgDetails="dataOrgDetails"></fdns-visithistory-leftsection>
    </div>
    <div class="visithistory-rightsection">
        <fdns-visithistory-rightsection :selectedReport="selectedReport" :selectOrgDetails="leftDataOrgDetails"></fdns-visithistory-rightsection>
    </div>
</div>
</template>

<script>
import mixins from "../../mixins.js"
import FDNSVisitHistoryLeftSection from "./FDNSVisitHistoryLeftSection.vue";
import FDNSVisitHistoryRightSection from "./FDNSVisitHistoryRightSection.vue";

export default {
  mixins: [mixins],
  data() {
    return {
      selectedReport: null,
      leftDataOrgDetails: ""
    };
  },
  created() {
    this.$store.commit("updateFDNSResetFDNSStore");
  },
  components: {
    "fdns-visithistory-leftsection": FDNSVisitHistoryLeftSection,
    "fdns-visithistory-rightsection": FDNSVisitHistoryRightSection
  },
  methods: {
    onClick(obj) {
      this.selectedReport = obj;

      this.$store.commit("updateFDNSSelectedReport", obj);
    },
    dataOrgDetails(t) {
      this.leftDataOrgDetails = t;
    }
  }
};
</script>
<style scoped>
.height-100 {
  height: 100%;
}
.visithistory-leftsection {
  width: 20%;
  float: left;
  border-right: 1px solid #a0a0a0;
  height: 100%;
  background: #fff;
}
.visithistory-rightsection {
  width: 80%;
  float: left;
  height: 100%;
  background: #fff;
  overflow: hidden;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/FDNS/FDNSTabs/FDNSVisitHistoryTab/FDNSVisitHistoryTab.vue